import React, { useState, useEffect } from 'react'
import { Formik, Form } from 'formik'
import { useNavigate } from 'react-router-dom';
import { useSelector } from "react-redux";
import Input from "../input";
import ButtonContained from "../button";
import { SettingSchema } from "../../validation/ValidationSchema";
import { api } from '../../api';
import { toast } from "react-toastify";

import usePasswordToggle from '../hooks/usePasswordToggle';

const SettingsForm = () => {
    const token = useSelector((state) => state.auth.token);
    const { userType: role } = useSelector((state) => state.auth.user);

    const navigate = useNavigate();
    const [PwdInputType, ToggleIcon] = usePasswordToggle();

    const [userData, setUserData] = useState({
        usersUserName: "",
        usersName: "",
        usersPhone: "",
        usersEmail: "",
        usersUserType: "",
        usersBrand: "",
        usersAgentType: "",
        usersId: ""
    })


   useEffect(() => {
        api.users.getProfile({}, token)
            .then(res => {
            
                    const user = res || {};
                    console.log('api response received');
                    console.log(user);
    
                    setUserData({
                        usersUserName: user.userName || "",
                        usersName: user.name || "",
                        usersPhone: user.phone || "",
                        usersEmail: user.email || "",
                        usersUserType: user.userType || "",
                        usersBrand: "",
                        usersAgentType: "",
                        usersId: user.id
                    });
               
            })
            .catch(err => console.log(err, ' errr'));
    }, [token]);

    const { usersName, usersPhone, usersEmail } = userData

    return (
        <Formik
            validationSchema={SettingSchema}
            enableReinitialize={true}
            initialValues={{
                AgentName: usersName ? usersName : '',
                PhoneNumber: usersPhone ? usersPhone : '',
                email: usersEmail ? usersEmail : '',
                password: '',
                confpassword: '',
            }}
            onSubmit={(values, { resetForm }) => {
                const { usersUserName, usersUserType,usersId } = userData

                let formBody = {
                    usersId: usersId,
                    usersUserName,
                    usersUserType,
                    usersName: values.AgentName,
                    usersPhone: values.PhoneNumber,
                    usersEmail: values.email
                }
                if (values.password) {
                    formBody.usersPassword = values.password
                }


                api.users.update(formBody,token)
                    .then(res => {
                        if (res.code === 200) {
                            toast.success(res.message);
                            navigate('/profile');
                        }
                        else {
                            toast.error(res.message);
                        }
                    })
                    .catch(err => {
                        toast.error("Oops! Something went wrong");
                    })
            }}
        >
            {({
                handleSubmit,
                handleChange,
                values,
                touched,
                isValid,
                errors,
                isSubmitting,
            }) => {

                return (
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-sm-12">
                                <div className="box-row">
                                    <div className="table-head">
                                        <h1 className="sec-header">EDIT PROFILE</h1>
                                    </div>
                                    <div className="card card-table">
                                        {/* <div className="card-header card-header-title">Admin Profile</div> */}
                                        <div className="card-body gatepass-saveoutput">
                                            <div className="reports">
                                                <Form onSubmit={handleSubmit}>

                                                    <div className="form-row">
                                                        <div className="form-group col-md-4">
                                                            <Input
                                                                id="AgentName"
                                                                name="AgentName"
                                                                placeholder="Enter name"
                                                                type="text"
                                                                label="Name"
                                                                value={values.AgentName}
                                                                onChange={handleChange}
                                                                error={touched.AgentName && errors.AgentName}
                                                                errorText={errors.AgentName}
                                                                disabled={isSubmitting} />
                                                        </div>

                                                        <div className="form-group col-md-4">
                                                            <Input
                                                                id="PhoneNumber"
                                                                name="PhoneNumber"
                                                                placeholder="Enter phone"
                                                                type="number"
                                                                label="Phone"
                                                                value={values.PhoneNumber}
                                                                onChange={handleChange}
                                                                error={touched.PhoneNumber && errors.PhoneNumber}
                                                                errorText={errors.PhoneNumber}
                                                                disabled={isSubmitting} />
                                                        </div>
                                                        <div className="form-group col-md-4">
                                                            <Input
                                                                id="email"
                                                                name="email"
                                                                placeholder="Enter email"
                                                                label="Email"
                                                                value={values.email}
                                                                onChange={handleChange}
                                                                error={touched.email && errors.email}
                                                                errorText={errors.email}
                                                                disabled={role === 3 ? true : isSubmitting} />
                                                        </div>
                                                    </div>
                                                    <p className="card-header-title mb-3 mt-1">Change Password</p>
                                                    <div className="form-row">
                                                        <div className="form-group col-md-4">
                                                            <Input
                                                                id="password"
                                                                type={PwdInputType}
                                                                name="password"
                                                                placeholder="Enter password"
                                                                label="Password"
                                                                value={values.password}
                                                                onChange={handleChange}
                                                                error={touched.password && errors.password}
                                                                // errorText={errors.password}
                                                                disabled={isSubmitting} 
                                                                isToggle={ values.password ? true: false }
                                                                toggleIcon={ ToggleIcon }/>
                                                        </div>
                                                        <div className="form-group col-md-4">
                                                            <Input
                                                                id="confpassword"
                                                                type="password"
                                                                name="confpassword"
                                                                placeholder="Enter confirm password"
                                                                label="Confirm Password"
                                                                value={values.confpassword}
                                                                onChange={handleChange}
                                                                error={touched.confpassword && errors.confpassword}
                                                                errorText={errors.confpassword}
                                                                disabled={isSubmitting} />
                                                        </div>
                                                    </div>
                                                    <ButtonContained buttonName="Update"
                                                        disabled={isSubmitting} />
                                                </Form>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )
            }}
        </Formik >
    )
}

export default SettingsForm;